var _path, _path2, _path3, _path4, _path5;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgGmail = function SvgGmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.364 20.004h3.181v-7.727L2 8.867v9.773c0 .755.611 1.364 1.364 1.364Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.455 20.004h3.181c.755 0 1.364-.612 1.364-1.364V8.867l-4.545 3.41",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.455 6.367v5.91L22 8.867V7.05c0-1.686-1.925-2.648-3.273-1.636",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.545 12.277v-5.91L12 10.459l5.455-4.09v5.909L12 16.367",
    fill: "#EA4335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.05v1.817l4.545 3.41v-5.91l-1.272-.954C3.923 4.402 2 5.363 2 7.049Z",
    fill: "#C5221F"
  })));
};

export default SvgGmail;